<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="frontmatter3"><a id="page_9"></a><span class="small"><strong>FOREWORD</strong></span></h2>
<p class="noindent">Storytelling is an art, and the fly-fishing world is full of great artists. Our stage is the world’s oceans, rivers, and lakes; our main players are leaky rowboats, dilapidated fishing vehicles, game wardens, mean dogs, rattlesnakes, dysfunctional relatives, screaming guides, and other assorted mischief makers.</p>
<p class="indent">On the road to and from our beloved waters, a good portion of a fly angler’s conversation concerns the reliving of the mind-boggling or sentimental experiences that make a good fishing story. With <em>Fifty Favorite Fly-Fishing Tales</em>, Chris Santella has rounded up a collection of one-of-a-kind tales from some of fly fishing’s most colorful personalities. (Reading through the epic adventure I shared with Chris, I still cringe and chuckle at the exploits of my youth!) I think anyone who has fished with a grandfather, or from a canoe, or anywhere in Montana, or with anyone who brings more beers than flies has an outrageous story that’s just waiting to be told. This book will make some people laugh and others cry, perhaps at the same time . . . because we’ve all been there.</p>
<p class="right">—B<span class="small">RIAN O</span>’K<span class="small">EEFE</span></p>
<p class="image"><a id="page_10"></a><img alt="Image" src="images/f0010-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter3.vue?2b1ab1ba